import * as d3 from "d3";

import { Observation } from "./ebird";
import { DoY, MoY } from "js/dateish";

type EBirdCode = string; // TODO

const whenAsc = (a: Observation, b: Observation) => a.date.when.getTime() - b.date.when.getTime();

export type DoYSpecies = Map<DoY, Map<EBirdCode, Map<number, Observation[]>>> // TODO: DayOfYear type
export function dayOfYearSpecies(all: Observation[]): DoYSpecies {
  const countable = all.filter(o => o.taxon.speciesCode != null);
  return d3.group(countable,
    obs => `${obs.date.month}-${obs.date.day}` as DoY,
    obs => obs.taxon.speciesCode!,
    obs => obs.date.year);
};

export type MoYSpecies = Map<MoY, Map<EBirdCode, Map<number, Observation[]>>>;
export function monthOfYearSpecies(all: Observation[]): MoYSpecies {
  const countable = all.filter(o => o.taxon.speciesCode != null);
  return d3.group(countable,
    obs => obs.date.month,
    obs => obs.taxon.speciesCode!,
    obs => obs.date.year);
}

export type SpeciesDoY = Map<EBirdCode, Map<string, Observation[]>>
export function speciesDayOfYear(countable: Observation[]): SpeciesDoY {
  return d3.group(countable,
    obs => obs.taxon.speciesCode!,
    obs => `${obs.date.month}-${obs.date.day}`);
}

export type SpeciesAny = Map<EBirdCode, Observation[]>
export function speciesAny(countable: Observation[]): SpeciesAny {
  return d3.group(countable, obs => obs.taxon.speciesCode!);
}

// TODO: Wrap in a class
export type Streak = Observation[]
// interface Streak<T extends Observation> extends Array<T> {}

export function dayDiff(a: Observation, b: Observation): number {
  return d3.timeDay.count(a.date.when, b.date.when);
}

export function streakDays(s: Streak): number {
  switch (s.length) {
    case 0: return 0;
    case 1: return 1;
  }
  return dayDiff(s[0], s.slice(-1)[0]) + 1;
}

// TODO: Make this function operate on a set of observations and return the sorted
// set of streaks. In the same vein as d3, it could take access function for getting
// the grouping key, access function for date getter, and the offset function for
// calculating the date differences.
//
// Could probably drop the grouping key and just make this the streaking function
// that I was thinking about for needs in d3.
export function speciesStreaks(countable: Observation[]): [EBirdCode, Streak[]][] {
  return Array.from(speciesAny(countable))
    .map(([spcode, observations]): [string, Streak[]] => {
      // Group them into streaks, sort by day delta,
      return [spcode,
        observations.sort(whenAsc)
          .reduce((streaks: Streak[], obs: Observation) => {
            const [current] = streaks.slice(-1);
            if (current != null && dayDiff(current.slice(-1)[0], obs) <= 1) {
              current.push(obs);
            } else {
              streaks.push([obs]);
            }
            return streaks;
          }, [])
          .sort((a, b) => streakDays(b) - streakDays(a))
        ];
    });
}

// TODO: Generalize my sort functions
export declare function sortBy<T extends object>(k: KeyOf<T>): (a: T, b: T) => number; // TODO: How to implement

type KeyOf<O extends object, Sep extends string = '.'> =
{[K in keyof O & (string|number)]: O[K] extends object
  ? `${K}` | `${K}${Sep}${KeyOf<O[K], Sep>}`
  : `${K}`
}[keyof O & (string|number)];